import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import InputBase from '@material-ui/core/InputBase'
import FilterIcon from '@material-ui/icons/FilterList'
import TodoTagInput from './todos/TodoTagInput'
import _ from 'lodash'
import LOG from '../logging/Logger'
import { MAX_LENGTH_FILTER_NAME } from '../data/limits'

const useStyles = makeStyles(theme => ({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  accoridon: {},
  input: {
    marginLeft: theme.spacing(1),
    flex: 1
  },
  iconButton: {
    padding: 10
  },
  divider: {
    height: 28,
    margin: 4
  },
  tags: {
    width: '100%',
    marginBottom: theme.spacing(2)
  },
  expandIcon: {
    '&$expanded': {
      transform: 'none'
    }
  },
  expanded: {}
}))

export default ({
  list,
  textFilter,
  onChangeTextFilter,
  tagsFilter,
  onChangeTagsFilter,
  getAvailableTags
}) => {
  LOG.debug('Render: Filter')

  const classes = useStyles()

  const isFiltered = () => {
    return (
      (textFilter && textFilter.length) || (tagsFilter && tagsFilter.length)
    )
  }

  return (
    <div>
      <Accordion
        className={classes.accordion}
        TransitionProps={{ unmountOnExit: true }}
      >
        <AccordionSummary
          classes={{
            expandIcon: classes.expandIcon,
            expanded: classes.expanded
          }}
          expandIcon={
            <FilterIcon color={isFiltered() ? 'secondary' : 'inherit'} />
          }
          aria-controls='panel1c-content'
          id='panel1c-header'
        >
          <InputBase
            className={classes.input}
            placeholder='Search / Filter List'
            inputProps={{
              'aria-label': 'filter',
              'data-lpignore': 'true',
              maxLength: MAX_LENGTH_FILTER_NAME
            }}
            onChange={e => onChangeTextFilter(e.target.value)}
            onClick={e => e.stopPropagation()}
            onFocus={e => e.stopPropagation()}
            value={textFilter}
          />
          <Button
            disabled={!isFiltered()}
            color='secondary'
            onClick={e => {
              onChangeTextFilter('')
              onChangeTagsFilter([])
              e.stopPropagation()
            }}
            onFocus={e => e.stopPropagation()}
          >
            Clear
          </Button>
        </AccordionSummary>
        <AccordionDetails className={classes.details}>
          <TodoTagInput
            className={classes.tags}
            label='Filter Tags...'
            tags={tagsFilter}
            getAutocompleteTags={() => _.sortBy(getAvailableTags(list))}
            onSetTags={onChangeTagsFilter}
          />
        </AccordionDetails>
      </Accordion>
    </div>
  )
}
